import Vue from 'vue';
import VModal from 'vue-js-modal';
import Notifications from 'vue-notification';
import Datepicker from 'vuejs-datepicker';
import Paginate from 'vuejs-paginate';
import VueTheMask from 'vue-the-mask';
import { library } from '@fortawesome/fontawesome-svg-core';
import VTooltip from 'v-tooltip';
import {
  faEye, faEyeSlash, faExclamation, faLock, faTachometerAlt, faUsers, faProjectDiagram,
  faAddressCard, faMobileAlt, faFileInvoiceDollar, faCashRegister, faCheckCircle,
  faStopCircle, faQuestionCircle, faCartPlus, faCogs, faPlusCircle, faTrash, faChartBar,
  faInfoCircle, faHistory, faSave,
} from '@fortawesome/free-solid-svg-icons';
import { faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as moment from 'moment/moment';
import App from './App.vue';
import router from './router';
import store from './store';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import './assets/style/app.scss';


library.add(faEye, faEyeSlash, faExclamation, faLock, faTachometerAlt, faUsers, faProjectDiagram,
  faAddressCard, faMobileAlt, faFileInvoiceDollar, faCashRegister, faCheckCircle, faStopCircle,
  faQuestionCircle, faCartPlus, faCogs, faPlusCircle, faTrash, faChartBar, faInfoCircle, faSave,
  faHistory, faTelegram, faWhatsapp);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('datepicker', Datepicker);
Vue.component('paginate', Paginate);
Vue.mixin({
  methods: {
    fixDate(event) {
      return moment(event).format('DD.MM.YYYY');
    },
    fixDateAndTine(event) {
      return moment(event).format('DD.MM.YYYY - HH:mm ');
    },
    fixDateToFilter(event) {
      return moment(event).format('YYYY-MM-DD');
    },
    InputFocusIn(key) {
      document.getElementById(key).parentNode.classList.add('filled');
    },
    InputFocusOut(key) {
      const el = document.getElementById(key);
      if (el.value.length > 0) {
        el.parentNode.classList.add('filled');
      } else {
        el.parentNode.classList.remove('filled');
      }
      el.parentNode.classList.remove('focused');
    },
  },
});
Vue.use(VModal, { dialog: true });
Vue.use(Notifications);
Vue.use(VueTheMask);
Vue.use(VTooltip);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
